module.exports = __webpack_public_path__ + "static/school_support_img1@2x-bc3f2bb012841d4098f6895bcb13d1a6.jpg";